import React, { useState, useEffect } from "react";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import CheckIcon from "../../icons/CheckIcon.svg";
import ClubOwnerOverviewStyle from "../../pages/ClubOwnerStyles/ClubOwnerOverviewStyle.module.css";

const Wallet = () => {
  const [stripeConnected, setStripeConnected] = useState(false);
  const [dashboardLink, setDashboardLink] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [buttonText, setButtonText] = useState("Create PATT Wallet");

  const adminId = localStorage.getItem("adminId");
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const checkStripeConnection = async () => {
      setIsLoading(true); // Start loading
      try {
        let token = localStorage.getItem("token");
        const response = await axios.get(
          `${BACKEND_URL}/admin/clubowners/getStripeId/${adminId}`,
          {
            headers: {
              authorization: `Bearer ${token}`
            }
          }
        );

        if (response.data && response.data.stripeId) {
          const accountResponse = await axios.get(
            `${BACKEND_URL}/admin/fetch-stripe-account-details/${response.data.stripeId}`,
            {
              headers: {
                authorization: `Bearer ${token}`
              }
            }
          );

          setStripeConnected(accountResponse.data.details_submitted);
        }
      } catch (error) {
        console.error("Error checking Stripe connection:", error);
        setStripeConnected(false);
      } finally {
        setIsLoading(false); // End loading
      }
    };

    checkStripeConnection();
  }, [adminId, BACKEND_URL]);

  const createStripeAccount = async () => {
    setIsButtonLoading(true);
    setButtonText("Setting up your wallet...");
    try {
      let token = localStorage.getItem("token");
      const response = await axios.post(
        `${BACKEND_URL}/admin/create-stripe-account-link`,
        {
          clubIds: adminId
        },
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      if (response.data.url) {
        // Redirect to Stripe Connect page
        window.location.href = response.data.url;
        // Indicator will continue until the redirection is complete
      }
    } catch (error) {
      console.error("Error creating Stripe account:", error);
      setIsButtonLoading(false); // Stop loading if there's an error
      setButtonText("Create PATT Wallet");
    }
  };

  const fetchStripeDashboardLink = async () => {
    try {
      let token = localStorage.getItem("token");
      const response = await axios.get(
        `${BACKEND_URL}/admin/generate-stripe-dashboard-link/${adminId}`,
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      setDashboardLink(response.data.url);
    } catch (error) {
      console.error("Error fetching Stripe dashboard link:", error);
    }
  };

  useEffect(() => {
    if (stripeConnected) {
      fetchStripeDashboardLink();
    }
  }, [stripeConnected]);

  if (isLoading) {
    return (
      <div
        className={ClubOwnerOverviewStyle.loadingContainer}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <ClipLoader color={"#00338d"} loading={isLoading} size={150} />
      </div>
    );
  }

  return (
    <div className={ClubOwnerOverviewStyle.dashboard}>
      <div className={ClubOwnerOverviewStyle.header}>
        <h1>PATT Wallet</h1>

        <div className={ClubOwnerOverviewStyle["stripe-section"]}>
          {stripeConnected ? (
            <div className={ClubOwnerOverviewStyle["stripe-connected"]}>
              <div className={ClubOwnerOverviewStyle["stripe-info"]}>
                <img src={CheckIcon} alt="Connected" />
                <h1>Check your balance in your PATT wallet!</h1>
              </div>
              {dashboardLink && (
                <button
                  onClick={() => window.open(dashboardLink, "_blank")}
                  className={ClubOwnerOverviewStyle["stripe-button"]}
                >
                  Go to PATT Wallet Dashboard
                </button>
              )}
            </div>
          ) : (
            <div className={ClubOwnerOverviewStyle["stripe-setup"]}>
              <h2>Setup Your PATT Wallet</h2>
              <p>
                To receive automatic direct payouts, you need to connect your
                bank account.
              </p>
              <button
                onClick={createStripeAccount}
                className={ClubOwnerOverviewStyle["stripe-button"]}
                disabled={isButtonLoading}
              >
                {isButtonLoading ? (
                  <>
                    <ClipLoader color="#fff" size={15} />
                    <span style={{ marginLeft: "8px" }}>{buttonText}</span>
                  </>
                ) : (
                  buttonText
                )}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Wallet;
